import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, Form, FormGroup, FormFeedback} from 'reactstrap'
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import CreatableSelect from '../../../Wps/CreatableSelect'
import FilterWpsSwitch from './FilterWpsSwitch'

const WPS_LIST_QUERY = gql`
  query WpsListQuery($project_id: ID) {
    wps_list(project_id: $project_id) {
      list {
        id
        no
        rev_no
        actual
      }
    }
  }
`

class WpsModal extends Component {
  constructor(props) {
    super(props)
    let initialWps = []

    if (props.weldData && !Array.isArray(props.weldData)) {
      if (Array.isArray(props.weldData.wps)) {
        initialWps = props.weldData.wps.map(w => ({ id: w.id, name: `${w.no}(${w.rev_no})` }))
      } else if (props.weldData.wps) {
        initialWps = [{ id: props.weldData.wps, name: String(props.weldData.wps) }]
      }
    }

    this.state = {
      wps_list: [],
      wps_by_weld: null,
      wps_id: initialWps
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    project_id: PropTypes.number.isRequired,
    weldData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
  }

  componentDidMount() {
    this.props.client.query({
      query: WPS_LIST_QUERY,
      variables: { project_id: String(this.props.project_id) },
      fetchPolicy: 'network-only'
    }).then(({ data }) => {
      const list = data.wps_list.list.filter(w => w.actual)
      this.setState({ wps_list: list })

      // resolve initial wps name if we only had id
      if (!Array.isArray(this.props.weldData) && this.props.weldData && !Array.isArray(this.props.weldData.wps) && this.props.weldData.wps) {
        const found = list.find(w => w.id === this.props.weldData.wps)
        if (found) this.setState({ wps_id: [{ id: found.id, name: `${found.no}(${found.rev_no})` }] })
      }
    })
  }

  handleSubmit(e) {
    e.preventDefault()

    // Handle multiple welds
    if (Array.isArray(this.props.weldData)) {
      this.props.onSubmit(this.state.wps_id.map(w => ({ id: w.id, no: w.name.split('(')[0] })), this.props.weldData)
    } else {
      // Single weld logic (existing)
      let currentWpsIds = Array.isArray(this.props.weldData.wps) ? this.props.weldData.wps.map(w => w.id) : (this.props.weldData.wps ? [this.props.weldData.wps] : [])
      let newWpsIds = this.state.wps_id.map(w => w.id)
      
      if (JSON.stringify(currentWpsIds.sort()) === JSON.stringify(newWpsIds.sort())) {
        this.props.onCancel()
      }
      else {
        this.props.onSubmit(this.state.wps_id.map(w => ({ id: w.id, no: w.name.split('(')[0] })))
      }
    }
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>WPS {Array.isArray(this.props.weldData) ? `(${this.props.weldData.length} welds)` : ''}</ModalHeader>
        <ModalBody>
          <Form id="welds-grid-wps-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
            {Array.isArray(this.props.weldData) ? (
              <FormFeedback>Assigning WPS to {this.props.weldData.length} selected welds</FormFeedback>
            ) : (
              !this.props.weldData.id && <FormFeedback>Save weld before to use WPS filter by weld requirements</FormFeedback>
            )}
            <CreatableSelect
              id="select-person-welding-log-form"
              label={<label>{!Array.isArray(this.props.weldData) && this.props.weldData.id &&
              <FilterWpsSwitch
                weld_id={Number(this.props.weldData.id)}
                updateWpsData={(wps) => this.setState({wps_by_weld: wps})}
              />}
              </label>}
              options={(this.state.wps_by_weld || this.state.wps_list).map(wps => ({
                name: `${wps.no}(${wps.rev_no})`,
                id: wps.id
              }))}
              valueKey="id"
              value={this.state.wps_id}
              multi={true}
              creatable={false}
              valueChangeFunction={wps => this.setState({wps_id: wps || []})}
            />
            <FormGroup>
              <hr/>
              <Button id="cancel-welding-log-form-btn" className="float-right" color="danger"
                onClick={this.props.onCancel}>Cancel</Button>
              <Button id="save-welding-log-form-btn" className="float-right" color="primary" type="submit">OK</Button>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}

export default withApollo(WpsModal)



// WEBPACK FOOTER //
// ./src/components/Welds/helpers/wps/WpsModal.js